import { fetchAcConfig } from '@ac/library-utils/dist/utils/ac-config';

const startApplication = async (): Promise<void> => {
  await fetchAcConfig();
  const { startStandalone } = await import('./setUp/standalone');
  startStandalone();
};

export {};

startApplication();
